import createAction from "../../../_common/utils/redux/createAction";

export const DASHBOARD__FILTRAR_PERIODO = "DASHBOARD/FILTRAR_PERIODO";

export const filtrarPorPeriodo = periodo => createAction(DASHBOARD__FILTRAR_PERIODO, periodo);
